﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

// When arriving from an external login provider when server side cookies are used, we want to make sure
// that there are no old accessTokens left in the browsers local storage. Therefore external logins that's not
// "sessionless" will be redirected through this page.

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import * as React from "react";
import { TokenRequestStatus, useAuthToken } from "~base/Services/API/AuthToken";
import { SplashPage } from "~base/Components/Pages/Shared/SplashPage";
import {
    ensureSameSiteUrl,
    getSameSiteSafeUrlParam,
} from "~base/Services/NavigateService";
import { useSettings } from "~base/Settings/SettingsContext";
import { useSearchParams } from "react-router-dom";

//-------------------------------------------------------------------------------------
// Props
//-------------------------------------------------------------------------------------

type ExternalLoginByCookieCallbackProps = unknown;

//-------------------------------------------------------------------------------------
// Component
//-------------------------------------------------------------------------------------

export const ExternalLoginByCookieCallbackPage: React.FunctionComponent<
    ExternalLoginByCookieCallbackProps
> = (_: ExternalLoginByCookieCallbackProps) => {
    const settings = useSettings();
    const [searchParams] = useSearchParams();
    const paramReturnUrl = getSameSiteSafeUrlParam(searchParams, "ReturnUrl");
    const [hasRedirected, setHasRedirected] = React.useState(false);

    const serverVirtualPath = settings.valueAsString("serverVirtualPath");

    useAuthToken({
        clearToken: true,
        callback: (status: TokenRequestStatus) => {
            if (status == "Cleared" && !hasRedirected) {
                setHasRedirected(true);
                const returnUrl = paramReturnUrl
                    ? ensureSameSiteUrl(paramReturnUrl)
                    : serverVirtualPath;
                window.location.href = returnUrl;
            }
        },
    });

    return <SplashPage showSplashScreen={false} isLoading={true}></SplashPage>;
};
